import EmployeeCalendar from "../feature/EmployeeCalendar";
import useCalendar from "../feature/useCalendar";

export default function TimeSheets() {
  const page = useCalendar();

  return page && <EmployeeCalendar page={page} />;
}
